import React, { type FC } from 'react'
import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import styled from '@emotion/styled'

import {
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Button,
  Flex,
  LINK_VARIANT_DEFAULT,
  Link,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  TEXT_VARIANT_STANDARD,
  Text,
} from 'mailup-web-components'

import IconPlus from 'Components/icons/IconPlus'

import {
  modalConfigColumnsAddColumnCallback,
  modalConfigColumnsCancelCallback,
  modalConfigColumnsConfirmCallback,
} from 'Pages/RecipientsList/recoil/callbacks/modals'

import {
  modalColumnsCanSaveState,
  modalColumnsState,
} from 'Pages/RecipientsList/recoil/state/modals'

import ColumnsList from 'Pages/RecipientsList/components/modals/columns/ColumnsList'

const StyledModalBody = styled(ModalBody)`
  max-height: calc(100vh - 400px);
`

const ModalConfigColumns: FC = () => {
  const intl = useIntl()
  const { show } = useRecoilValue(modalColumnsState)

  const handleCancel = useRecoilCallback(modalConfigColumnsCancelCallback, [])

  const handleConfirm = useRecoilCallback(modalConfigColumnsConfirmCallback, [])

  const canConfirm = useRecoilValue(modalColumnsCanSaveState)

  const handleAddColumn = useRecoilCallback(
    modalConfigColumnsAddColumnCallback,
    [],
  )

  return (
    <Modal
      show={show}
      onClose={handleCancel}
      data-mu-test="modal-config-columns"
      closeOnOverlayClick
      showClose
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.RecipientsList.ModalConfigColumnsTitle',
        })}
      />

      <span tabIndex={0} />

      <StyledModalBody scrollable>
        <Flex flexDirection="column" gap="16px">
          <Text variant={TEXT_VARIANT_STANDARD}>
            {intl.formatMessage({
              id: 'Load.RecipientsList.ModalConfigColumnsIntro',
            })}
          </Text>

          <ColumnsList />

          <Link
            variant={LINK_VARIANT_DEFAULT}
            data-mu-test="recipients-add-filter"
            onClick={handleAddColumn}
            alignContent
            gap="4px"
          >
            <IconPlus width="12" height="16" />
            {intl.formatMessage({ id: 'Load.RecipientsList.AddColumn' })}
          </Link>
        </Flex>
      </StyledModalBody>

      <ModalFoot>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          data-mu-test="cancel"
          onClick={handleCancel}
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        </Button>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          data-mu-test="confirm"
          onClick={handleConfirm}
          disabled={!canConfirm}
        >
          {intl.formatMessage({
            id: 'Load.MailupCommon.Save',
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalConfigColumns
